import React from "react"
import { graphql, Link } from "gatsby";
import Layout from "../components/layout";
import "./blog.css";
import Head from "../components/head";
import Img from "gatsby-image"

export default function Template({
 data, // this prop will be injected by the GraphQL query below.
}) {

 const { markdownRemark,file } = data // data.markdownRemark holds your post data
 const { frontmatter, html, fields } = markdownRemark;
 const {childImageSharp} = file;
 const { fluid } = childImageSharp
//  console.log(frontmatter.tags)
 const Tags = () => {
   if(frontmatter.tags){
    //  console.log(frontmatter.tags)
    const listTags = frontmatter.tags.map((tag,index) =>    <li key={index} className="tag">{tag}</li>  );
     return(
       <ul className="listTags">
         {listTags}
       </ul>
     )
   }
 }
 const Author = () =>(
   <div className="author">
     <img src="/assets/profil.jpg" alt="profil" />
     <h3>par: fredydev</h3>
     <p>A security expert & full-stack web developer. Works with technologies including HTML + CSS, JavaScript, React, GraphQL, Node.js, Express, and MongoDB.</p>


   </div>
 )
 return (
     <Layout>        
        <Head title={frontmatter.title} />
        <div className="blog-post-container">
        
            <div className="blog-post">
              <div className="blog-post-info">
                <h1>{frontmatter.title}</h1>
                <p className="frontmatter">posted in <Link to={frontmatter.categorie}>{frontmatter.categorie} </Link>on {frontmatter.date}, </p>
                <span className="frontmatter">{fields.readingTime.text}</span>
                <Author />
                {frontmatter.tags && <Tags  />}
              </div>
              <Img
                fluid={fluid}
                objectFit="cover"
                objectPosition="50% 50%"
                alt={frontmatter.title}
              />
              
              <div className="blog-post-content" dangerouslySetInnerHTML={{ __html: html }} />
            </div>
        </div>
   </Layout>
 )
}
export const pageQuery = graphql`query($slug: String, $featuredImage: String) {
  markdownRemark(frontmatter: { path: { eq: $slug } }) {
    html
    frontmatter {
      date(formatString: "MMMM DD, YYYY")
      path
      title
      tags
      categorie
      thumbnail
    }
    fields {
      readingTime {
        text
      } 
    }
  }
  file(relativePath: { eq: $featuredImage }) {
    childImageSharp {
      # Specify the image processing specifications right in the query.
      # Makes it trivial to update as your page's design changes.
      fluid(maxWidth: 1000) {
        ...GatsbyImageSharpFluid
      }
    }
  }
 }`

 